import { all, call } from "redux-saga/effects"

import { optionsSagas } from "./options/options.sagas"
import { categoriesSagas } from "./categories/categories.sagas"
import { platformsSagas } from "./platforms/platforms.sagas"
import { userSagas } from "./user/user.sagas"
import { estimationsSagas } from "./estimations/estimations.sagas"
import { configurationSagas } from "./configuration/configuration.sagas"

export default function* rootSaga() {
  yield all([
    call(optionsSagas),
    call(categoriesSagas),
    call(platformsSagas),
    call(userSagas),
    call(estimationsSagas),
    call(configurationSagas),
  ])
}
